import { Box } from "@mui/material";
import { useEffect, useRef } from "react";
import useVirtualViewport from "../../../hooks/useVirtualViewport";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  setHasScroll,
  setMessages,
  setOpenAuthSidebar,
  setOpenDriverSidebar,
  setOpenOwnerSidebar,
} from "../../../redux/features/settingSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux";
import DriverSidebar from "./Sidebar";
import BottomTabbar from "./BottomTabbar";
import CustomSnackbar from "../../components/CustomSnackbar";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../services/fetcher";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../redux/features/snackbarSlice";
import {
  setAccomodationInfo,
  setAttachFiles,
  setBankAccountInfo,
  setBirthDate,
  setDriverLicensePlate,
  setDriverNobatQueueInfo,
  setFullName,
  setMobileNr,
  setNationalCode,
  setPhoneValid,
  setSmartCart,
  setUserConfirm,
  setUserStock,
  setVehicleSmartCard,
  setlicenseNumber,
  setloaderTypeGroup,
  setloaderTypeName,
} from "../../../redux/features/userSlice";
import Goftino from "../../components/Goftino";

import JMoment from "jalali-moment";
import CustomDialogBox from "../../components/CustomDialogBox";

export default function DriverLayout() {
  const token = localStorage.getItem("access_token");

  const divRef = useRef<HTMLDivElement>(null);

  const viewport = useVirtualViewport();

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const { isOpenKeyboard } = useAppSelector((state) => state.settings);

  const { trigger: getVehicleInfoTrigger } = useSWRMutation(
    [`/Vehicle/GetVehicleInfo`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        const { vehicle } = data;
        if (vehicle.loaderTypeName) {
          const firstTowDigits = vehicle.licensePlateNr.slice(4, 6);
          const lastThiredDigits = vehicle.licensePlateNr.slice(0, 3);
          const alpha = vehicle.licensePlateNr.slice(3, 4);

          dispatch(
            setDriverLicensePlate({
              firstTowDigits,
              lastThiredDigits,
              alpha,
              licensePlateSerial: vehicle.licensePlateSerial,
            })
          );
          dispatch(setVehicleSmartCard(vehicle.smartCard));
        }

        if (!vehicle.smartCard) {
          navigate("complete-info");
        }
      },
    }
  );

  const { trigger: getDriverbarTrigger } = useSWRMutation(
    [`/Driver/GetDriverBar`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        const { vehicleSmartCard, stock } = data;

        if (vehicleSmartCard) {
          dispatch(setSmartCart(vehicleSmartCard));
          dispatch(setUserStock(stock));

          try {
            const resp = await getVehicleInfoTrigger({
              smartCard: vehicleSmartCard,
            });

            const { vehicle, loaderGroup } = resp;

            const { loaderTypeName } = vehicle;

            dispatch(setloaderTypeGroup(loaderGroup));

            dispatch(setloaderTypeName(loaderTypeName));
          } catch (e) {
            console.log(e);
          }
        } else {
          if (pathname.split("/")[1] === "driver") navigate("/complete-info");
        }
      },
    }
  );

  const { trigger: getUserInfoTrigger } = useSWRMutation(
    [`/User/GetUserInfo`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        const { smartCard, role, phoneValid, isConfirm } = data;

        if (role === 21) return navigate("/owner/dashboard");

        dispatch(setSmartCart(smartCard));
        dispatch(setPhoneValid(phoneValid));
        dispatch(setUserConfirm(!!isConfirm));
      },
    }
  );

  const { trigger: getUserInfoTriggerr } = useSWRMutation(
    [`/Driver/GetDriverUserInfo`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        const {
          userName,
          phoneNumber,
          isConfirm,
          lastName,
          firstName,
          accountNr,
          cardNr,
          licenseNumber,
          shNr,
          birthDate,
          bankName,
          postalCode,
          address,
          cityInfo,
          driverAttach1,
          driverAttach2,
          driverAttach3,
          driverAttach4,
        } = data;

        dispatch(setFullName(firstName + " " + lastName));
        dispatch(setUserConfirm(isConfirm));
        dispatch(setMobileNr(phoneNumber));
        dispatch(setNationalCode(userName));

        const mydate = JMoment(birthDate);

        dispatch(
          setBirthDate({
            day: birthDate ? mydate.format("jDD") : "",
            month: birthDate ? mydate.format("jMM") : "",
            year: birthDate
              ? (Number(mydate.format("jYYYY")) - 1320).toString()
              : "",
          })
        );

        dispatch(setlicenseNumber(licenseNumber || ""));

        dispatch(
          setBankAccountInfo({
            accountNr,
            cardNr,
            shNr,
            bankName,
          })
        );

        dispatch(
          setAccomodationInfo({
            postalCode,
            address,
            cityInfo,
          })
        );

        dispatch(
          setAttachFiles({
            driverAttach1: driverAttach1,
            driverAttach2: driverAttach2,
            driverAttach3: driverAttach3,
            driverAttach4: driverAttach4,
          })
        );
      },
    }
  );

  const { trigger: getDriverNobatQueueInfo } = useSWRMutation(
    [`/Nobat/GetDriverNobatQueueInfo`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        dispatch(setDriverNobatQueueInfo(data));
        dispatch(setMessages(data.messages));
      },
    }
  );

  useEffect(() => {
    if (!token) return;
    getUserInfoTrigger();
    getUserInfoTriggerr();
    getDriverNobatQueueInfo();
    getDriverbarTrigger();
  }, []);

  useEffect(() => {
    dispatch(setOpenSnackbar(false));
    dispatch(setHasScroll(false));
    setTimeout(() => {
      dispatch(setOpenAuthSidebar(false));
      dispatch(setOpenDriverSidebar(false));
      dispatch(setOpenOwnerSidebar(false));
    }, 100);
  }, [pathname]);

  useEffect(() => {
    const divElement = divRef.current;

    const handleScroll = () => {
      if (divElement && divElement.scrollTop > 5) {
        dispatch(setHasScroll(true));
      } else {
        dispatch(setHasScroll(false));
      }
    };

    if (divElement) {
      divElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (divElement) {
        divElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  if (!token) return <Navigate to={"/login"} replace />;

  return (
    <Box
      ref={divRef}
      dir="rtl"
      sx={{
        height: `100vh`,
        backgroundColor: "bgColor.grey100",
        paddingBottom: pathname === "/driver/dashboard" ? "58px" : "70px",
        paddingTop: pathname === "/driver/dashboard" ? "0px" : "70px",
        position: "relative",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        overflowX: "hidden",
        "&::-webkit-scrollbar": {
          "-webkit-appearance": "none",
          width: "0px", // Hides scrollbar for WebKit browsers
        },
        scrollbarWidth: "none", // Hides scrollbar for Firefox
      }}
    >
      <CustomDialogBox />
      <DriverSidebar />
      <CustomSnackbar />
      <Goftino />
      <Outlet />
      <BottomTabbar />
    </Box>
  );
}
